// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2idvJ","list":"PatternAutocomplete_list__2iga7"};